/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-var */

import { _UnCryptMailto, _linkTo_UnCryptMailto } from './mail-crypt';
import _Toast from './toasts';

export default {};

// Global declaration
declare const UnCryptMailto: typeof _UnCryptMailto;
declare const linkTo_UnCryptMailto: typeof _linkTo_UnCryptMailto;
declare const treePosition: number[];
declare const Toast: typeof _Toast;

// Global scope augmentation
// eslint-disable-next-line no-use-before-define
var window: Window | null = window || null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _global = (window || global) as any;

const globalFunctions = {
  UnCryptMailto: _UnCryptMailto,
  linkTo_UnCryptMailto: _linkTo_UnCryptMailto,
  treePosition: [] as number[],
  Toast: _Toast,
};

Object.assign(_global, globalFunctions);
